import Styled from 'styled-components'

export const Container = Styled.div`
`
export const ContainerProduct = Styled.div`
`

export const Banner = Styled.div`
`

export const Content = Styled.div`
`

export const Cashback = Styled.p`
`

export const Title = Styled.h1`
`

export const Spots = Styled.p`
`
export const Details = Styled.p`
`

export const CuttingStitches = Styled.del`
`

export const Description = Styled.p`
`

export const DivVariant = Styled.div`
`

export const SoldBy = Styled.p`
`

export const Space = Styled.div`
`
